function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Menu_svg__b{fill:#16110d}"));

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  className: "Menu_svg__b",
  width: 20,
  height: 2,
  rx: 1,
  transform: "translate(2 5)"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "Menu_svg__b",
  width: 20,
  height: 2,
  rx: 1,
  transform: "translate(2 11)"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  className: "Menu_svg__b",
  width: 20,
  height: 2,
  rx: 1,
  transform: "translate(2 17)"
});

function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+PGRlZnM+PHN0eWxlPi5ie2ZpbGw6IzE2MTEwZH08L3N0eWxlPjwvZGVmcz48cmVjdCBjbGFzcz0iYiIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIiIHJ4PSIxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyIDUpIi8+PHJlY3QgY2xhc3M9ImIiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyIiByeD0iMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiAxMSkiLz48cmVjdCBjbGFzcz0iYiIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIiIHJ4PSIxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyIDE3KSIvPjwvc3ZnPg==";
export { SvgMenu as ReactComponent };